import React, {useState} from "react"
import {PurcsPreview, PreviewModes} from "@vp/react-product-preview"
import {getAccessToken} from "../../../utils/auth"
import {PurcsData} from "../../../dtos/orderResponse"
import SwanConfiguration from "./SwanConfiguration"
import {makeStyles} from "tss-react/mui"
import {Modal, Box} from "@mui/material"
import {Carousel, Card, BasicResponsiveImage, FlexBox} from "@vp/swan"

interface ExpandedDesignProps {
	locale: string
	productKey: string
	purcsData: PurcsData
	workRevisionId: string
	tenantId: string
	tenantForPurcs: string
	previewInstructionsUri: string
	optionSelections: object
	docReferenceUrl: string
	livePreviewUrl: string
	itemPreviewUrls?: string
}

const useStyles = makeStyles()({
	previewContainer: {
		cursor: "pointer",
		minHeight: "300px",
		display: "flex",
		alignItems: "center",
	},
	previewImage: {
		borderTop: "2px solid whitesmoke",
		borderBottom: "2px solid whitesmoke",
	},
	modal: {
		position: "absolute",
		top: "50%",
		right: "50%",
		transform: "translate(50%,-50%)",
		border: "0px",
		outline: "none",
		width: "60%",
		height: "80%",
		"&:focus": {
			boxShadow: "none !important",
		},
	},
})

export function ExpandedDesign(props: ExpandedDesignProps) {
	const {classes} = useStyles()

	const [open, setOpen] = useState(false)
	function handleOpen() {
		setOpen(true)
	}

	function handleClose() {
		setOpen(false)
	}
	const itemPreviewUrlsArray = props.itemPreviewUrls ? JSON.parse(props.itemPreviewUrls) : []
	return (
		<SwanConfiguration>
			<div>
				<div className={classes.previewContainer} onClick={handleOpen}>
					<div className={classes.previewImage}>
						{props.livePreviewUrl && !props.livePreviewUrl.includes("sportswear") ? (
							<PurcsPreview
								purcsOrigin="https://lookup.previews.cimpress.io"
								requestor="care-console"
								previewMode={PreviewModes.FirstPageOnly}
								bearerToken={getAccessToken()}
								docRefURL={props.docReferenceUrl}
								locale={props.locale}
								coreProductKey={props.productKey}
								optionSelections={props.optionSelections}
								width={300}
								previewInstructionsUri={props.previewInstructionsUri}
								style={{display: "block", width: "100%"}}
							/>
						) : (
							<img src={props.livePreviewUrl} width="300px" alt="" />
						)}
					</div>
				</div>
				<Modal open={open} onClose={handleClose}>
					<div className={classes.modal}>
						<Box
							sx={{
								maxHeight: "100%",
								maxWidth: "100%",
								overflowY: "auto",
							}}
						>
							{props.livePreviewUrl &&
							props.livePreviewUrl.includes("sportswear") &&
							props.itemPreviewUrls &&
							itemPreviewUrlsArray &&
							itemPreviewUrlsArray.length > 0 ? (
								<Carousel
									aria-label="Carousel Preview of the document"
									accessibleTextForPrevious="Go to previous document"
									accessibleTextForNext="Go to next document"
									aria-roledescription="carouselPreviews"
									skin="full"
									slidesToShow={1}
								>
									{itemPreviewUrlsArray.map((link: string, index: number) => {
										return (
											<Card bordered key={index}>
												<FlexBox flexDirection={"row"}>
													<BasicResponsiveImage aspectRatio={9 / 16} src={link} height={"600px"} />
												</FlexBox>
											</Card>
										)
									})}
								</Carousel>
							) : (
								<PurcsPreview
									purcsOrigin="https://lookup.previews.cimpress.io"
									requestor="care-console"
									previewMode={PreviewModes.Carousel}
									bearerToken={getAccessToken()}
									docRefURL={props.docReferenceUrl}
									locale={props.locale}
									coreProductKey={props.productKey}
									optionSelections={props.optionSelections}
									previewInstructionsUri={props.previewInstructionsUri}
								/>
							)}
						</Box>
					</div>
				</Modal>
			</div>
		</SwanConfiguration>
	)
}
